import jsCookie from 'js-cookie';

const cookieOptions = {
  expires: 30,
  path: '/',
  domain: '',
  sameSite: 'None',
};
const expiredCookieOptions = {
  expires: -1,
  path: '/',
  domain: '',
  sameSite: 'None',
};

const isSupportStorage = () => {
  try {
    localStorage.setItem('____name', 'meme');
  } catch (e) {
    return false;
  }
  return true;
};

/**
 * 设置缓存
 * @param key
 * @param val
 * @param days  缓存时间，单位 天
 */
const setItem = (key: string, val: any, days: number = 0) => {
  if (!cookieOptions.domain && typeof location !== 'undefined') {
    cookieOptions.domain = location.hostname;
    expiredCookieOptions.domain = location.hostname;
  }

  if (days) {
    val = {
      expires: days,
      data: val,
    };
  }
  val = JSON.stringify(val || '');
  if (isSupportStorage()) {
    localStorage.setItem(key, val);
  } else {
    val = JSON.stringify(val || '');
    jsCookie.set(key, val, cookieOptions);
  }
};

type StoreData = {
  expires: number;
  data: any;
} | null;

const getItem = (key: string) => {
  let valObj: any;
  let valStr: any = '';
  if (isSupportStorage()) {
    valStr = localStorage.getItem(key) || '';
  } else {
    valStr = jsCookie.get(key);
  }
  try {
    valObj = JSON.parse(valStr);
    // 过期
    if (valObj && valObj.expires) {
      if (valObj.expires < Date.now()) {
        valObj = null;
      } else {
        valObj = valObj.data;
      }
    }
    return valObj;
  } catch (e) {
    return valStr;
  }
};

const remove = (key: string) => {
  if (isSupportStorage()) {
    localStorage.removeItem(key);
  } else {
    jsCookie.remove(key);
  }
};

const clear = () => {
  if (isSupportStorage()) {
    localStorage.clear();
  } else if (document) {
    let cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i];
      let eqPos = cookie.indexOf('=');
      let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie =
        name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
    }
    if (cookies.length > 0) {
      for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i];
        let eqPos = cookie.indexOf('=');
        let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        let domain = location.host.substr(location.host.indexOf('.'));
        document.cookie =
          name +
          '=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=' +
          domain;
      }
    }
  }
};

export default {
  getItem,
  setItem,
  remove,
  clear,
};
